import { Submission } from './services/submissions';
import Icon from '../components/Icons/Icon';
import { submitNoteEdit } from '../helpers/galleryHelper';
import { useReducer } from 'react';
import { decodeHtmlCharCodes } from '../helpers/textHelper';

const SubmissionCard = (props: {submission: Submission, openModal: Function}) => {

    let { submission, openModal } = props;
    const [, forceUpdate] = useReducer(x => x + 1, 0);

    return (
        <div key={submission.id} style={{padding: 16, margin: 16, backgroundColor: 'white', flexDirection: 'column', borderRadius: 16, display: 'flex', width: 224, maxWidth: 224, boxShadow: '0px 2px 4px 0px #000000AA'}}>
            <div style={{display: 'flex', marginBottom: 16, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                <div className="P2Bold">
                    {submission.firstName +  ' ' + submission.lastName}
                </div>
                <div className="P2">
                    {submission.date_submitted}
                </div>
            </div>
            <div style={{position: 'relative'}}>
                <div className={"admin-img-status-badge " + (submission.status ? submission.status : 'pending')}>{submission.status ? submission.status.charAt(0).toUpperCase() + submission.status.slice(1) : "Pending"}</div>
                <div className="admin-img-container" onClick={()=>openModal(submission.index)}>
                    <img className='admin-submission-img' src={submission.thumbnail ? submission.thumbnail : ''} alt={submission.filename}/>
                </div>
            </div>
            <div className="P2">
                {decodeHtmlCharCodes(submission.location)}
            </div>
            <div className="admin-submission-note-container" style={{marginTop: 8, display: 'inline-block'}} onClick={()=>{
                    let new_content = window.prompt('Enter new note content', submission.noteContent || '');
                    if (new_content !== submission.noteContent) {
                        submitNoteEdit(submission.id, new_content);
                        if (!new_content) new_content = '';
                        submission.noteContent = new_content;
                        forceUpdate();
                    }
                }}>
                <span >
                    <Icon name="Edit" size={24}/>
                </span>
                {decodeHtmlCharCodes(submission.noteContent)}
            </div> 
        </div>
    )
}

export default SubmissionCard;